import { useContext } from 'react';
import { MyContext } from '../Store';
import { Sketches } from './Sketches';
import { getSortedColorSketches, getViewName } from '../utils';

export const Preview = () => {
  const [state, dispatch] = useContext(MyContext);
  const { colorData, selectedView } = state;

  const sortedColorSketches = getSortedColorSketches(colorData.sketches);

  const handleViewSelect = viewName => {
    dispatch({ type: 'SET_SELECTED_VIEW', payload: viewName });
  };

  return (
    <main className="preview">
      <Sketches selectedView={selectedView} className="preview__sketches"></Sketches>
      <div className="preview__view-select">
        {sortedColorSketches.map(sketch => (
          <div
            onClick={() => handleViewSelect(sketch.name)}
            className={`preview__view-select--item vertical-center ${sketch.name === selectedView ? 'active' : ''}`}
            key={sketch.name}
          >
            <div className="preview__view-select--item-image vertical-center">
              <img src={sketch.image} className="sketch" alt="key" />
            </div>
            <div className="preview__view-select--item-label">{getViewName(sketch.name)}</div>
          </div>
        ))}
      </div>
    </main>
  );
};
